import { UserOutlined } from '@ant-design/icons';
import "./UserHeader.scss";

interface UserHeaderProps {
    profileImage?: string;
    name: string;
};

export const UserHeader = (p: UserHeaderProps) => {
    const { profileImage, name } = p;

    return (
        <div className="user-header-container">
            <div className="user-header-profile-image">
                {
                    profileImage === '' || profileImage === undefined
                    ?
                    <UserOutlined className="user-header-icon"/>
                    :
                    <div className="user-header-image">
                        <img
                            id="userHeaderImage"
                            src={profileImage}
                            alt="Profilna slika" />
                    </div>
                }
            </div>
            <div className="user-header-data">
                <div className="user-header-name">{name.split(' ')[0]}</div>
                <div className="user-header-name">{name.split(' ')[1]}</div>
            </div>
        </div>
    );
};
